/**
 * admin-ops-api の `/api/v1/trials`（トライアル中 WS の介入リスト）client。#1705 SS-07。
 * `workspaces-api.ts` と同じ fetch ラッパの形。
 */

/** 自動判定の理由 + Founder 手動フラグ。API が合流させて返す。 */
export type TrialReason =
  | 'setup_incomplete'
  | 'no_lead'
  | 'active_no_progress'
  | 'pricing_interest'
  | 'high_fit'
  | 'inquiry';

/** 手動で立てられるフラグ（自動判定の理由は含まない）。 */
export type TrialFlagKey = 'high_fit' | 'inquiry';

export interface TrialListRow {
  workspaceId: string;
  createdAt: string;
  trialEndsAt: string | null;
  quickstartDoneCount: number;
  leadCount: number;
  hasFollowUpSet: boolean;
  loginDaysLast7: number;
  billingViewedCount: number;
  checkoutStarted: boolean;
  reasons: TrialReason[];
  manualFlags: Array<{ flagKey: TrialFlagKey; note: string | null }>;
}

export interface TrialListResult {
  configured: boolean;
  rows: TrialListRow[];
  note?: string;
}

function base(baseUrl: string): string {
  return `${baseUrl.replace(/\/$/, '')}/api/v1/trials`;
}

export async function fetchTrials(baseUrl: string): Promise<TrialListResult> {
  const res = await fetch(base(baseUrl), {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error(`admin-ops API /trials failed: ${res.status}`);
  return (await res.json()) as TrialListResult;
}

/** 手動フラグを立てる / 外す。 */
export async function setTrialFlag(
  baseUrl: string,
  workspaceId: string,
  flagKey: TrialFlagKey,
  enabled: boolean,
): Promise<void> {
  const res = await fetch(`${base(baseUrl)}/${workspaceId}/flags/${flagKey}`, {
    method: enabled ? 'PUT' : 'DELETE',
    credentials: 'include',
    headers: { Accept: 'application/json' },
  });
  if (!res.ok) throw new Error(`admin-ops API /trials flag failed: ${res.status}`);
}
